import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { CustomerSideMenu } from '../customer-side-menu/customer-side-menu';
import { CustomersService } from '../customers-service';
import { CustomersApisService } from '../customers-apis-service';
import { ToastService } from '../../../core/services/toast/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomerI } from '../interfaces/customer.interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DelegatedUIErrorI } from '../../shared/interfaces/delegated-ui-error.interface';

@Component({
  selector: 'app-customer-details',
  imports: [RouterOutlet, CustomerSideMenu],
  templateUrl: './customer-details.html',
  styleUrl: './customer-details.scss',
})
export class CustomerDetails implements OnInit {
  private readonly customersApisService = inject(CustomersApisService);
  private readonly customersService = inject(CustomersService);

  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);

  private readonly route = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef);

  constructor() {}

  customerID!: string;
  customer!: CustomerI | null;

  ngOnInit(): void {
    this.getCustomerFromRoute();
  }

  getCustomerFromRoute() {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((paramMap) => {
        const customerID = paramMap.get('customerID');
        if (!customerID) {
          this.toastService.showError(
            this.translateService.instant('errors.contactTechnicalSupport')
          );
        } else {
          this.customerID = customerID;
          this.findOneCustomer(customerID);
        }
      });
  }

  findOneCustomer(customerID: string) {
    this.customersApisService
      .findOneCustomer(customerID)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (deleteResponse) => {
          const { data } = deleteResponse;
          this.customer = data;

          this.customersService.selectedCustomer.set(this.customer);
        },
        error: (err: DelegatedUIErrorI) => {
          this.toastService.showError(err.description, err.title);
        },
      });
  }
}
